import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { $crossenv } from 'util/crossenv';
import { clearLocalStorage } from 'data/storage';

// 模型定义和应用相关的数据以及操作
type InitialState = {
  error: string;
  messageKey: string;
  /** 页面被嵌入 */
  beEmbedded: boolean;
};

const initialState = {
  error: '',
  messageKey: 'app_global',
  beEmbedded: false
} as InitialState;

const app = createSlice({
  name: 'app',
  initialState: initialState,
  reducers: {
    setAppError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    appMessageClose() {
      message.destroy();
    },
    appMessageLoading(state, action: PayloadAction<string>) {
      if (!action.payload) return;
      message.loading({
        content: action.payload,
        key: state.messageKey
      });
    },
    appMessageSuccess(state, action: PayloadAction<string>) {
      if (!action.payload) return;
      message.success({
        content: action.payload,
        key: state.messageKey,
        duration: 3
      });
    },
    appMessageError(state, action: PayloadAction<string>) {
      if (!action.payload) return;
      message.error({
        content: action.payload,
        key: state.messageKey,
        duration: 3
      });
    },
    appMessageWarn(state, action: PayloadAction<string>) {
      if (!action.payload) return;
      message.warn({
        content: action.payload,
        key: state.messageKey,
        duration: 3
      });
    },
    appRedirectAfterLogout() {
      const logOutUrl = $crossenv.data.ssoLogoutUrl;
      clearLocalStorage();
      location.href = `${logOutUrl}`;
    },
    setBeEmbedded(state, action: PayloadAction<boolean>) {
      state.beEmbedded = action.payload;
    }
  }
});

export default app.reducer;

export const resetAppData = createAction('app/resetAppData');

export const { setAppError, appMessageSuccess, appMessageError, appMessageWarn, appMessageLoading, appMessageClose, appRedirectAfterLogout, setBeEmbedded } =
  app.actions;
